import React, { useState, useContext } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../services/api";
import ToastContext from "../contexts/ToastContext";
import "./Auth.css";
import backgroundImage from "../assets/imagem-prefeitura.jpg";
import { FaLock, FaSave } from "react-icons/fa";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const { addToast } = useContext(ToastContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (senha !== confirmarSenha) {
      addToast("As senhas não coincidem.", "error");
      return;
    }
    try {
      const { data } = await api.post(`/auth/reset-password/${token}`, {
        senha,
      });
      addToast(data.message, "success");
      navigate("/login");
    } catch (error) {
      addToast(
        error.response?.data?.message || "Erro ao redefinir senha.",
        "error"
      );
    }
  };

  return (
    <div
      className="auth-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="auth-card">
        <h1>Redefinir Senha</h1>
        <form onSubmit={handleSubmit} className="form-modern">
          <div className="form-group">
            <label htmlFor="senha">Nova Senha</label>
            <div>
              <FaLock />
              <input
                type="password"
                id="senha"
                placeholder="Digite sua nova senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="confirmarSenha">Confirmar Nova Senha</label>
            <div>
              <FaLock />
              <input
                type="password"
                id="confirmarSenha"
                placeholder="Confirme sua nova senha"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="form-actions full-width">
            <button type="submit" className="btn-modern">
              <FaSave size={20} />
              <span>Salvar Nova Senha</span>
            </button>
          </div>
          <div className="auth-links">
            <p>
              Lembrou a senha? <Link to="/login">Voltar para o login</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
